import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "product-content-block" }
const _hoisted_3 = { class: "product-content-block__wrapper" }
const _hoisted_4 = { class: "product-content-block__wrapper-text" }
const _hoisted_5 = { class: "product-content-block__wrapper-text-inner" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "product-content-block__button"
}
const _hoisted_10 = { class: "product-content-block__button-inner" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 0,
  class: "product-content-block__carousel"
}
const _hoisted_14 = {
  key: 1,
  class: "product-content-block__images"
}
const _hoisted_15 = {
  key: 2,
  class: "product-content-block__wrapper-image product-content-block__wrapper-image--empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_element = _resolveComponent("image-element")!
  const _component_video_player = _resolveComponent("video-player")!
  const _component_lazy_load = _resolveComponent("lazy-load")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_ctx.headline || _ctx.text)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.headline)
                  ? (_openBlock(), _createElementBlock("h2", {
                      key: 0,
                      class: "product-content-block__headline headline headline--type_h2",
                      innerHTML: _ctx.headline
                    }, null, 8 /* PROPS */, _hoisted_6))
                  : _createCommentVNode("v-if", true),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (_ctx.subline)
                  ? (_openBlock(), _createElementBlock("h3", {
                      key: 1,
                      class: "product-content-block__subline",
                      innerHTML: _ctx.subline
                    }, null, 8 /* PROPS */, _hoisted_7))
                  : _createCommentVNode("v-if", true),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.useReadMore ? 'read-more' : 'div'), {
                  class: "product-content-block__read-more",
                  "text-more": "ads.main.detail.read_more",
                  "text-less": "ads.main.detail.read_less",
                  "max-height": _ctx.settings.readMoreHeight,
                  "scroll-less-element": `.${_ctx.readMoreTargetClass}`
                }, {
                  default: _withCtx(() => [
                    (_ctx.text)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "product-content-block__description",
                          innerHTML: _ctx.text
                        }, null, 8 /* PROPS */, _hoisted_8))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["max-height", "scroll-less-element"])),
                _cache[4] || (_cache[4] = _createTextVNode()),
                (_ctx.link1Text || _ctx.link2Text)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.link1Text)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "button button--text button--link-arrow product-content-block__button-link",
                              href: _ctx.link1Url
                            }, _toDisplayString(_ctx.link1Text), 9 /* TEXT, PROPS */, _hoisted_11))
                          : _createCommentVNode("v-if", true),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        (_ctx.link2Text)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "button button--text button--link-arrow product-content-block__button-link",
                              href: _ctx.link2Url
                            }, _toDisplayString(_ctx.link2Text), 9 /* TEXT, PROPS */, _hoisted_12))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _cache[5] || (_cache[5] = _createTextVNode()),
            (_ctx.carouselItems.length > 0)
              ? (_openBlock(), _createBlock(_component_lazy_load, {
                  key: 0,
                  class: _normalizeClass(["product-content-block__wrapper-image", {
            'product-content-block__wrapper-image--one-slide': _ctx.carouselItems.length < 2
          }])
                }, {
                  default: _withCtx(() => [
                    (_ctx.showCarousel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_carousel, {
                            class: "product-content-block__carousel-images",
                            "slides-count": _ctx.carouselItems.length,
                            "slides-per-view-desktop": 1,
                            "slides-per-view-mobile": 1,
                            "slides-per-view-tablet": 1,
                            "show-pagination": true,
                            "lazy-loading": true,
                            "preload-slide-count": 0,
                            onChange: _ctx.onCarouselChange,
                            onCreated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCarouselChange(0)))
                          }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                            _renderList(_ctx.carouselItems, (item, index) => {
                              return {
                                name: `slide-${index}`,
                                fn: _withCtx(() => [
                                  _createVNode(_component_lazy_load, {
                                    class: _normalizeClass(`product-content-block__image-wrapper slide-${index}`)
                                  }, {
                                    default: _withCtx(() => [
                                      (!item.videoId)
                                        ? (_openBlock(), _createBlock(_component_image_element, {
                                            key: 0,
                                            class: "product-content-block__picture",
                                            "img-class": "product-content-block__image product-content-block__image--auto-center",
                                            "src-mobile": [item.bigMobile],
                                            src: [item.big],
                                            alt: _ctx.headline,
                                            loading: "eager",
                                            webp: _ctx.useWebp(item.big)
                                          }, null, 8 /* PROPS */, ["src-mobile", "src", "alt", "webp"]))
                                        : (item.videoId)
                                          ? (_openBlock(), _createBlock(_component_video_player, {
                                              key: 1,
                                              class: "product-content-block__video",
                                              "video-data": item,
                                              onPlayFromStart: ($event: any) => (_ctx.trackVideoPlay(item)),
                                              ref: "videoPlayersRef"
                                            }, null, 8 /* PROPS */, ["video-data", "onPlayFromStart"]))
                                          : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
                                ])
                              }
                            })
                          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["slides-count", "onChange"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `product-content-block-${index}`,
                              class: _normalizeClass(`product-content-block__image-wrapper slide-${index}`)
                            }, [
                              _createVNode(_component_image_element, {
                                class: "product-content-block__picture",
                                "img-class": "product-content-block__image product-content-block__image--auto-center",
                                "src-mobile": [image.bigMobile],
                                src: [image.big],
                                alt: _ctx.headline,
                                webp: _ctx.useWebp(image.big)
                              }, null, 8 /* PROPS */, ["src-mobile", "src", "alt", "webp"])
                            ], 2 /* CLASS */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class"]))
              : (!_ctx.images || _ctx.images.length <= 0 && _ctx.fallbackImage)
                ? (_openBlock(), _createBlock(_component_lazy_load, {
                    key: 1,
                    class: "product-content-block__wrapper-image"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_image_element, {
                        class: "product-content-block__picture",
                        "img-class": "product-content-block__image product-content-block__image--auto-center",
                        "src-mobile": [_ctx.fallbackImage],
                        src: [_ctx.fallbackImage],
                        alt: _ctx.headline
                      }, null, 8 /* PROPS */, ["src-mobile", "src", "alt"])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_15))
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}